export default "__VITE_ASSET__C4au8WMz__$_?url__"